module.exports = __webpack_public_path__ + "img/bellmetal-image-LBT.9bf3c635.jpg";